module.exports = __webpack_public_path__ + "img/med-c4.b99a437f.svg";